import { Controller } from '@hotwired/stimulus';
import { useMatchMedia } from 'stimulus-use';

import {
  preventBodyScroll,
  restoreScrollableBody,
} from '../utilities/scrollHelpers.js';

export default class extends Controller {
  initialize() {}

  connect() {
    this.initialized = true;
    useMatchMedia(this, {
      mediaQueries: {
        md: '(min-width: 992px)',
      },
    });
    this.isDesktopLayout = window.matchMedia(
      '(min-width: 992px)'
    ).matches;
    this.drawerTarget.addEventListener('keydown', (event) => {
      if (event.key === 'Escape') {
        this.toggle();
        this.triggerTarget.focus();
      }
    });
  }

  static targets = [
    'drawer',
    'bg',
    'trigger',
    'openIcon',
    'closeIcon',
  ];

  static values = {
    active: Boolean,
  };

  mdChanged({ name, media, matches, event }) {
    this.isDesktopLayout = matches;
    this.resetAll();
  }

  toggle(e) {
    this.setActiveValue();
    this.toggleIcon();
    this.toggleDrawer();
    if (this.activeValue) {
      preventBodyScroll();
    } else {
      restoreScrollableBody(this.initialized);
    }
    this.toggleOverlayBg();
    this.setAriaLabels();
    this.triggerTarget.focus();
  }

  setActiveValue() {
    this.activeValue = !this.activeValue;
  }

  toggleDrawer() {
    this.drawerTarget.classList.toggle(
      'translate-x-full',
      !this.activeValue
    );
  }

  toggleOverlayBg() {
    this.bgTarget.classList.toggle('opacity-50', this.activeValue);
    this.bgTarget.classList.toggle('opacity-0', !this.activeValue);
    this.bgTarget.classList.toggle('hidden', !this.activeValue);
  }

  toggleIcon() {
    this.closeIconTarget.classList.toggle(
      'hidden',
      !this.activeValue
    );
    this.openIconTarget.classList.toggle('hidden', this.activeValue);
  }

  setAriaLabels() {
    this.drawerTarget.setAttribute(
      'aria-hidden',
      this.activeValue ? false : true
    );
    this.triggerTarget.setAttribute(
      'aria-expanded',
      this.activeValue ? true : false
    );
    this.bgTarget.setAttribute(
      'aria-hidden',
      this.activeValue ? false : true
    );
  }

  resetAll() {
    this.closeIconTarget.classList.add('hidden');
    this.openIconTarget.classList.remove('hidden');
    this.drawerTarget.classList.add('translate-x-full');
    if (this.activeValue) {
      restoreScrollableBody(this.initialized);
    }
    this.bgTarget.classList.remove('opacity-50');
    this.bgTarget.classList.add('opacity-0');
    this.bgTarget.classList.add('hidden');
    this.drawerTarget.setAttribute('aria-hidden', true);
    this.triggerTarget.setAttribute('aria-expanded', false);
    this.bgTarget.setAttribute('aria-hidden', true);
    this.activeValue = false;
  }
}
